// import { currentLocale } from '../../../i18n';
import languageManager from '@/scripts/assets/scripts/languageManager';
import { WebService } from '@/scripts/assets/scripts/platform/WebService';
/**
 * 货币符号转换
 */
export enum MONEY_SYMBOL {
    'cn' = '￥', //不使用中文
    'en-ZA' = '₹', //印度语
    'en-IN' = '₹', //印度英语
    'en-PH' = '₱', //菲律宾
    'en-ID' = 'Rp', //印度尼西亚
    'en-NG' = '₦', //尼日利亚
    'pt-BR' = 'R$', //巴西
    'es-MX' = '$', //墨西哥
    'my-MM' = '', //缅甸 - 新增

    //€欧元 £英镑
}

/**
 * 货币符号转换(英文)
 */
enum MONEY_SYMBOL_ENGLISH {
    'cn' = 'CNY', //不使用中文
    'en-ZA' = 'INR', //印度语
    'en-IN' = 'INR', //印度英语
    'en-PH' = 'PHP', //菲律宾
    'en-ID' = 'IDR', //印度尼西亚
    'en-NG' = 'NGN', //尼日利亚
    'pt-BR' = 'BRL', //巴西
    'es-MX' = 'MXN', //墨西哥
    'my-MM' = 'MMK', //缅甸 - 新增
    //€欧元 £英镑
}

class gameUtil {
    private static instance: gameUtil;

    private constructor() { } // 私有构造函数，防止外部实例化

    static get Instance(): gameUtil {
        if (!this.instance) {
            this.instance = new gameUtil();
        }
        return this.instance;
    }

    // static instance: gameUtil = null!;
    // static get Instance(): gameUtil {
    //     if (!this.instance) this.instance = new gameUtil();
    //     return this.instance;
    // }

    /**
     * 检测是否是远程地址
     * @param url
     * @returns
     */
    checkRemoteUrl(url: string): boolean {
        return (
            typeof url == 'string' &&
            (url.indexOf('https://') != -1 || url.indexOf('http://') != -1)
        );
    }
    /**
     * 格式化数字
     * @param num 需要格式化的数字
     * @param length 保留小数点位数
     * @param isForce 是否强制保留两位小数，默认为false
     * @param isHavePoint 是否在有小数点时强制保留length小数，默认为false
     * @param isForceSymbol 是否强制显示货币符号，默认为true
     * @returns
     */
    // 格式化数字，添加符号
    /**
     * 格式化数字，添加符号
     */
    formatNumWithSymbol(
        num: number | string | Number | String | undefined | null,
        length: number = null!,
        isForce: boolean = false,
        isHavePoint: boolean = false,
        isForceSymbol: boolean = true
    ): string {
        if (num == null || num == undefined) {
            return '0';
        }
        if (num == 'max') {
            return '∞';
        }
        let tempNum: any = num;
        if (typeof num == 'string') {
            tempNum = parseFloat(num);
        }

        if (isNaN(tempNum)) {
            return num as string;
        }
        num = tempNum;
        if (typeof num == 'number') {
            const locale = languageManager.getCurrentLocale();
            // 缅甸语特殊处理：大金额缩短显示
            if (locale == 'my-MM') {
                return this.formatMMK(num, length, true);
                // return this.formatMyanmarCurrency(num, length);
            }

            let newLen = length ? length : 2;
            let temp = Math.pow(10, newLen);
            num = Math.round(num * temp) / temp;
            let strNum: string = num.toString();
            if (length != null) {
                strNum = num.toFixed(length);
            } else {
                strNum = num.toFixed(2);
            }

            let temp_symbol = '';
            let useGrouping = isForceSymbol;

            // 各国数字格式化
            if (locale == 'pt-BR') {
                // 巴西：逗号小数点，点号千分位 1.234.567,89
                strNum = parseFloat(strNum).toLocaleString('pt-BR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: newLen,
                    useGrouping: useGrouping,
                });
                temp_symbol = ',';
            } else if (locale == 'en-ZA' || locale == 'en-IN') {
                // 印度：点号小数点，逗号千分位 12,34,567.89
                strNum = parseFloat(strNum).toLocaleString('en-IN', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: newLen,
                    useGrouping: useGrouping,
                });
                temp_symbol = '.';
            } else if (locale == 'es-MX') {
                // 墨西哥：点号小数点，逗号千分位 1,234,567.89
                strNum = parseFloat(strNum).toLocaleString('es-MX', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: newLen,
                    useGrouping: useGrouping,
                });
                temp_symbol = '.';
            } else if (locale == 'fil-PH' || locale == 'en-PH') {
                // 菲律宾：点号小数点，逗号千分位 1,234,567.89
                strNum = parseFloat(strNum).toLocaleString('fil-PH', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: newLen,
                    useGrouping: useGrouping,
                });
                temp_symbol = '.';
            } else if (locale == 'id-ID') {
                // 印度尼西亚：逗号小数点，点号千分位 1.234.567,89
                strNum = parseFloat(strNum).toLocaleString('id-ID', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: newLen,
                    useGrouping: useGrouping,
                });
                temp_symbol = ',';
            } else if (locale == 'en-NG') {
                // 尼日利亚：点号小数点，逗号千分位 1,234,567.89
                strNum = parseFloat(strNum).toLocaleString('en-NG', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: newLen,
                    useGrouping: useGrouping,
                });
                temp_symbol = '.';
            } else if (locale == 'my-MM') {
                // 缅甸：点号小数点，逗号千分位 1,234,567.89
                strNum = parseFloat(strNum).toLocaleString('my-MM', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: newLen,
                    useGrouping: useGrouping,
                });
                temp_symbol = '.';
            } else {
                // 默认：点号小数点，逗号千分位 1,234,567.89
                strNum = parseFloat(strNum).toLocaleString('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: newLen,
                    useGrouping: useGrouping,
                });
                temp_symbol = '.';
            }

            if ((isForce || isHavePoint) && length != null) {
                strNum = this.processDecimalPart(strNum, length, temp_symbol, !isHavePoint);
            }
            return strNum;
        }
        return num as string;
    }

    /**
     * 缅甸货币金额缩短格式化
     * @param num 金额
     * @param decimalPlaces 小数位数
     */
    private formatMyanmarCurrency(num: number, decimalPlaces: number = 2): string {
        const absNum = Math.abs(num);

        // 定义缅甸语金额单位
        const units = [
            { value: 1e12, symbol: 'ထရီလီယံ', enSymbol: 'T' }, // Trillion
            { value: 1e9, symbol: 'ဘီလီယံ', enSymbol: 'B' }, // Billion
            { value: 1e6, symbol: 'သန်း', enSymbol: 'M' }, // Million
            { value: 1e5, symbol: 'သိန်း', enSymbol: 'L' }, // Lakh (10万)
            { value: 1e3, symbol: 'ထောင်', enSymbol: 'K' }, // Thousand
        ];

        // 查找合适的单位
        for (const unit of units) {
            if (absNum >= unit.value) {
                const formattedValue = num / unit.value;

                // 根据数值大小决定小数位数
                let decimals = decimalPlaces;
                if (unit.value >= 1e6) {
                    decimals = Math.min(decimalPlaces, 2); // 百万以上最多2位小数
                } else if (unit.value >= 1e3) {
                    decimals = Math.min(decimalPlaces, 1); // 千到十万最多1位小数
                }

                const valueStr = this.formatDecimal(formattedValue, decimals);

                // 返回格式：数值 + 缅甸语单位符号
                return `${valueStr}${unit.symbol}`;
            }
        }

        // 小于1000的数值，使用正常格式化
        return parseFloat(num.toFixed(decimalPlaces)).toLocaleString('my-MM');
    }

    private formatMMK(
        amount: number,
        decimal: number = 1, // 小数位数
        useGrouping: boolean = false, // 是否使用千分位
        useMyanmarDigits: boolean = false // 是否显示缅甸数字
    ): string {
        if (isNaN(amount)) return '0';

        let value = amount;
        let suffix = '';
        const d = decimal == null ? 1 : Math.max(0, Math.floor(decimal));

        if (amount >= 1_000_000_000) {
            value = amount / 1_000_000_000;
            suffix = 'B';
        } else if (amount >= 1_000_000) {
            value = amount / 1_000_000;
            suffix = 'M';
        } else if (amount >= 1000) {
            value = amount / 1000;
            suffix = 'K';
        } else {
            const factor = Math.pow(10, d);
            const truncated = Math.trunc(value * factor) / factor;
            const str = truncated.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: d,
                useGrouping,
            });
            return useMyanmarDigits ? this.toMyanmarNumber(str) : str;
        }

        // 格式化大数字，保留小数位，可选千分位
        const formatted = useGrouping
            ? value
                .toLocaleString('en-US', {
                    minimumFractionDigits: d,
                    maximumFractionDigits: d,
                })
                .replace(/\.0+$/, '')
            : (Math.trunc(value * Math.pow(10, d)) / Math.pow(10, d))
                .toFixed(d)
                .replace(/\.0+$/, '');

        return useMyanmarDigits
            ? this.toMyanmarNumber(`${formatted}${suffix}`)
            : `${formatted}${suffix}`;
    }

    /**
     * 阿拉伯数字转缅甸数字
     */
    private toMyanmarNumber(str: string): string {
        const arabicToMyanmar: Record<string, string> = {
            '0': '၀',
            '1': '၁',
            '2': '၂',
            '3': '၃',
            '4': '၄',
            '5': '၅',
            '6': '၆',
            '7': '၇',
            '8': '၈',
            '9': '၉',
            '.': '.',
            ',': ',',
            K: 'K',
            M: 'M',
            B: 'B',
        };

        return str
            .split('')
            .map(c => arabicToMyanmar[c] ?? c)
            .join('');
    }

    /**
     * 格式化小数部分
     */
    private formatDecimal(value: number, decimalPlaces: number): string {
        if (decimalPlaces === 0) {
            return Math.round(value).toString();
        }

        let formatted = value.toFixed(decimalPlaces);

        // 移除不必要的 .0 或 .00
        if (decimalPlaces > 0) {
            formatted = formatted.replace(/\.?0+$/, '');
        }

        return formatted;
    }
    /**
     * 查找小数点(指定位数)后有没有足够的位数,不够时补齐0
     * @param input 要查找的字符串
     * @param maxLength 需要保留的最大位数
     * @param symbol 检查的符号(巴西为,印地为.)
     * @param isForce 是否强制保留，默认为true，如果为false，则有小数点的情况下才保留
     * @returns
     */
    processDecimalPart(
        input: string,
        maxLength: number,
        symbol: string,
        isForce: boolean = true
    ): string {
        // 查找小数点的位置
        if (typeof input == 'number') {
            input = (input as Number).toString();
        }
        const dotIndex = input.indexOf(symbol);

        if (dotIndex !== -1) {
            // 存在小数点
            if (maxLength === 0) {
                // maxLength 为 0，删除小数点及其后面的部分
                return input.slice(0, dotIndex);
            }
            // 存在小数点
            const decimalPart = input.slice(dotIndex + 1);

            if (decimalPart.length > maxLength) {
                // 超过指定长度，截取小数点后的部分
                return input.slice(0, dotIndex + 1) + decimalPart.slice(0, maxLength);
            } else {
                // 不够指定长度，用0补齐
                const addedZeros = '0'.repeat(maxLength - decimalPart.length);
                return input.slice(0, dotIndex + 1) + decimalPart + addedZeros;
            }
        } else {
            // 不存在小数点
            if (!isForce) {
                return input;
            } else {
                return input + symbol + '00';
            }
        }
    }

    /**
     * 把时间戳转换成时间字符串
     * @param timestamp 时间戳（毫秒）
     * @param isHaveSecond 是否精确到秒,默认精确到秒
     * @returns
     */
    formatTimeByTimestamp(timestamp: number | Date, isHaveSecond: boolean = true) {
        if (!timestamp) {
            return '';
        }
        const date = new Date(timestamp);
        let timezone = 'en-US';
        let options: Intl.DateTimeFormatOptions = {};
        const locale = languageManager.getCurrentLocale();

        if (locale == 'pt-BR') {
            //巴西
            timezone = 'pt-BR';
            options = {
                timeZone: 'America/Sao_Paulo',
                hour12: false,
            };
        } else if (locale == 'en-ZA' || locale == 'en-IN') {
            //印度
            timezone = 'en-IN';
            options = {
                timeZone: 'Asia/Kolkata',
                hour12: false,
            };
        } else if (locale == 'es-MX') {
            //墨西哥
            timezone = 'es-MX';
            options = {
                timeZone: 'America/Mexico_City',
                hour12: false,
            };
        } else if (locale == 'fil-PH') {
            //菲律宾
            timezone = 'fil-PH';
            options = {
                timeZone: 'Asia/Manila',
                hour12: false,
            };
        } else if (locale == 'id-ID') {
            //印度尼西亚
            timezone = 'id-ID';
            options = {
                timeZone: 'Asia/Jakarta',
                hour12: false,
            };
        } else if (locale == 'en-NG') {
            //尼日利亚
            timezone = 'en-NG';
            options = {
                timeZone: 'Africa/Lagos',
                hour12: false,
            };
        } else if (locale == 'my-MM') {
            //缅甸 - 新增
            timezone = 'my-MM';
            options = {
                timeZone: 'Asia/Yangon', // 仰光时区
                hour12: false,
            };
        }

        options.year = 'numeric';
        options.month = '2-digit';
        options.day = '2-digit';
        options.hour = '2-digit';
        options.minute = '2-digit';
        options.formatMatcher = 'basic';
        if (isHaveSecond) {
            options.second = '2-digit';
        }

        try {
            const formatter = new Intl.DateTimeFormat(timezone, options);
            const formattedString = formatter.format(date);
            const withoutComma = formattedString.replace(/,/g, '');
            return withoutComma;
        } catch (error) {
            console.error('转换时间失败', error);
            return '';
        }
    }

    formatTo8AMLocalString(date: Date): string {
        const newDate = new Date(date);
        newDate.setHours(0, 0, 0, 0); // 设置为早上 08:00

        const locale = navigator.language;

        const dateStr = new Intl.DateTimeFormat(locale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
        }).format(newDate);

        const timeStr = new Intl.DateTimeFormat(locale, {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
        }).format(newDate);
        //return `${dateStr} ${timeStr}`
        return this.formateTime(newDate);
    }

    formatDateIntl(locale: string, day: number, month: number, year?: number): string {
        const date = new Date(year ?? 2025, month - 1, day);
        const options: Intl.DateTimeFormatOptions = year
            ? { day: 'numeric', month: 'long', year: 'numeric' }
            : { day: 'numeric', month: 'long' };

        return new Intl.DateTimeFormat(locale, options).format(date);
    }

    /**
     * @description 取得一个区间的随机整数
     * @param {*} n 起始值
     * @param {*} m 结束值
     */
    randomNum(minNumber: number, maxNumber: number) {
        let random = Math.floor(Math.random() * (maxNumber - minNumber + 1) + minNumber);
        return random;
    }

    /**
     * 转换货币符号
     */
    converMoneySymbol() {
        const locale = languageManager.getCurrentLocale();
        return MONEY_SYMBOL[locale as keyof typeof MONEY_SYMBOL];
    }

    /**
     * 转换货币符号成英文字母
     */
    converMoneySymbol_English() {
        const locale = languageManager.getCurrentLocale();
        return MONEY_SYMBOL_ENGLISH[locale as keyof typeof MONEY_SYMBOL_ENGLISH];
    }
    animateNumber(
        elementId: string,
        currentValue: number,
        targetValue: number,
        time: number = 1.5,
        callBack?: Function,
        isShowAdd: boolean = false
    ) {
        const element = document.getElementById(elementId);
        if (!element) {
            console.warn(`Element with id "${elementId}" not found.`);
            return;
        }
        currentValue = Number(currentValue);
        targetValue = Number(targetValue);
        if (currentValue >= targetValue) {
            element.innerText = (isShowAdd ? '+' : '') + this.formatNumWithSymbol(targetValue);
            callBack && callBack();
            return;
        }
        const frameRate = 30; // 每秒帧数
        const totalFrames = Math.round(time * frameRate); //总共多少份
        let increment = (targetValue - currentValue) / totalFrames; //步长
        if (increment < 0.01) {
            increment = 0.01;
        }

        let current = currentValue; //当前的值
        let frame = 0; //增加次数

        const update = () => {
            frame++;
            current += increment;
            if (
                (increment > 0 && current >= targetValue) ||
                (increment < 0 && current <= targetValue)
            ) {
                current = targetValue;
                callBack && callBack();
            }

            element.innerText = (isShowAdd ? '+' : '') + this.formatNumWithSymbol(current);

            if (current < targetValue) {
                requestAnimationFrame(update);
            }
        };

        update();
    }

    isValidPhone(value: string): boolean {
        // return /^[1-9]\d{10}$/.test(value);
        const locale = languageManager.getCurrentLocale();
        if (locale == 'pt-BR') {
            return this.isValidBrazilianMobilePhone(value);
        } else if (locale == 'my-MM') {
            return this.isValidMMPhone(value);
        }
        return /^[1-9]\d{10}$/.test(value);
    }

    isValidBrazilianMobilePhone(phone: string): boolean {
        // 清除所有非数字字符
        const clean = phone.replace(/\D/g, '');

        // 必须是 11 位：2 位 DDD + 9 位手机号
        if (clean.length !== 11) return false;

        const ddd = clean.slice(0, 2); // 区号
        const number = clean.slice(2); // 手机号

        // 非法 DDD 列表
        const invalidDDDs = [
            '20',
            '30',
            '40',
            '50',
            '60',
            '70',
            '80',
            '90',
            '39',
            '56',
            '57',
            '58',
            '59',
        ];

        // 检查 DDD 合法性
        const dddNumber = parseInt(ddd, 10);
        const isDDDValid = dddNumber >= 11 && dddNumber <= 99 && !invalidDDDs.includes(ddd);

        // 手机号必须以 9 开头，且长度为 9 位
        const isMobileValid = /^9\d{8}$/.test(number);

        return isDDDValid && isMobileValid;
    }

    /**
     * 验证手机号是否符合缅甸格式（09 开头，7-9 位数字）
     */
    isValidMMPhone(phone: string): boolean {
        const clean = phone.replace(/\D/g, '');
        return /^0?9\d{7,9}$/.test(clean);
    }

    /**
     * @description 验证钱包ID是否符合要求（11位数字）
     * @param walletID 钱包ID
     * @returns 是否符合要求
     */
    validateWalletID(walletID: string) {
        // 去掉前后空格
        const trimmed = walletID.trim();

        // 校验是否是 11 位数字
        const isValid = /^\d{11}$/.test(trimmed);

        return isValid;
    }

    isValidEmail(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    isAllNumbers(value: string): boolean {
        return /^\d+$/.test(value);
    }

    isValidPsd(psd: string): boolean {
        return psd.length >= 8 && psd.length <= 20;
    }

    /**
     * 在 URL 中检查并添加多个参数（支持带 # 的 hash 路由）
     * @param url 原始URL
     * @param params 参数对象，例如 { token: '123', lang: 'en' }
     * @returns 处理后的URL
     */
    appendQueryParamsWithHash(url: string, params: Record<string, string>): string {
        try {
            const [baseUrl, hash = ''] = url.split('#');
            const urlObj = new URL(baseUrl, location.origin);

            Object.entries(params).forEach(([key, value]) => {
                if (!urlObj.searchParams.has(key)) {
                    urlObj.searchParams.append(key, value);
                }
            });

            const finalUrl = urlObj.toString().replace(location.origin, '');
            return hash ? `${finalUrl}#${hash}` : finalUrl;
        } catch (e) {
            console.error('URL格式错误', e);
            return url;
        }
    }
    getQueryParamAll(url = window.location.href) {
        const params = new URL(url).searchParams;
        return params;
    }
    getQueryParam(key: string, url = window.location.href) {
        const params = new URL(url).searchParams;
        return params.get(key);
    }

    getCookies() {
        const cookies: any = {};
        const cookieString = document.cookie;
        if (!cookieString) {
            return cookies;
        }
        cookieString.split(';').forEach(cookie => {
            const [key, value] = cookie.trim().split('=');
            if (key) {
                // cookies[key.trim()] = decodeURIComponent(value.trim());
                cookies[key.trim()] = value ? value.trim() : undefined;
            }
        });
        console.log(cookies);
        return cookies;
    }
    /**
     * 融合Cookies 和 URL参数 并返回新的对象
     * @returns
     */
    mergeParams() {
        const urlParams = new URLSearchParams(window.location.search);
        const queryParams: any = {};
        for (const [key, value] of urlParams) {
            queryParams[key] = value;
        }
        const cookieParams = this.getCookies();
        return {
            ...cookieParams,
            ...queryParams,
            visitorId: this.getVisitroId(),
        };
    }
    getVisitroId() {
        let visitorId = localStorage.getItem('visitorId');
        if (!visitorId?.trim()) {
            try {
                // 优先使用 crypto.randomUUID()，若不支持则回退到 uuidv4() 或其他方法
                visitorId =
                    typeof crypto !== 'undefined' && crypto.randomUUID
                        ? crypto.randomUUID()
                        : this.generateFallbackUUID();
                localStorage.setItem('visitorId', visitorId);
            } catch (e) {
                console.error('无法存储 visitorId:', e);
                // 隐私模式下仍返回生成的 ID，只是不存储
            }
        }
        return visitorId;
    }
    // 兼容性回退：生成随机 UUID
    generateFallbackUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    pureUrlParams() {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        if (params.has('type')) params.delete('type');
        if (params.has('open')) params.delete('open');
        if (params.has('path')) params.delete('path');
        if (params.has('usource')) params.delete('usource');
        if (params.has('time')) params.delete('time');
        if (params.has('v')) params.delete('v');
        if (params.has('token')) params.delete('token');
        if (params.has('appTest')) params.delete('appTest');
        return params;
    }

    openHome(type: 'open' | 'href' | 'reload' = 'href') {
        const baseUrl = `${window.location.protocol}//${window.location.host}`;
        const url = new URL(window.location.href);
        var params: URLSearchParams = this.pureUrlParams();
        if (params.has('type')) params.delete('type');
        if (params.has('open')) params.delete('open');
        var gameHome = `${baseUrl}/`;
        if (params.toString().length > 0) {
            gameHome = `${gameHome}?${params.toString()}`;
        }
        console.log('跳转首页', gameHome);
        if (isRunApp()) {
            WebService.appOpenURL(gameHome);
            return;
        }
        if (type == 'open') {
            window.open(gameHome, '_blank');
        } else if (type == 'href') {
            window.location.href = gameHome;
        } else if (type == 'reload') {
            window.location.reload();
        }
    }

    openDownload(type: 'open' | 'href' | 'reload' = 'href') {
        const baseUrl = `${window.location.protocol}//${window.location.host}`;
        var params: URLSearchParams = this.pureUrlParams();
        if (isRunApp()) {
            params.set('usource', '3');
        } else if (isRunningAsPWA()) {
            params.set('usource', '2');
        } else {
            params.set('usource', '1');
        }
        if (!params.has('isNoRobot')) {
            params.set('isNoRobot', 'true');
        }
        // const url = new URL(window.location.href);
        //url.search = params.toString();
        // window.history.pushState({}, '', url.toString());
        var gameHome = `${baseUrl}/download/`;
        if (params.toString().length > 0) {
            gameHome = `${gameHome}?${params.toString()}`;
        }
        console.log('跳转下载页面', gameHome);
        if (isRunApp()) {
            WebService.appOpenURL(gameHome);
            return;
        }
        if (type == 'open') {
            window.open(gameHome, '_blank');
        } else if (type == 'href') {
            window.location.href = gameHome;
        } else if (type == 'reload') {
            window.location.reload();
        }
        // window.open(`${window.location.origin}/download/?${params.toString()}`, '_blank');
    }

    formateTime(time: string | Date): string {
        if (!time) {
            return '';
        }
        const locale = languageManager.getCurrentLocale();
        if (locale == 'pt-BR') {
            return this.toBrazilianDateFormat(time);
        }
        if (time instanceof Date) return this.formatDate(time);
        return time;
    }

    // 格式化日期为 YYYY.MM.DD HH:mm
    formatDate(date: Date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}.${month}.${day} ${hours}:${minutes}`;
    }

    /**把时间转换成巴西时间格式 */
    private toBrazilianDateFormat(input: string | Date, withTime: boolean = true): string {
        let dateObj: Date | undefined;

        if (input instanceof Date && !isNaN(input.getTime())) {
            dateObj = input;
        } else if (typeof input === 'string') {
            // 手动解析仅支持 YYYY-MM-DD、YYYY.MM.DD、YYYY/MM/DD 等明确格式
            const match = input.match(
                /^(\d{4})[./-](\d{1,2})[./-](\d{1,2})(?:\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?)?$/
            );
            if (!match) return input;

            let [, year, month, day, hour = '0', minute = '0', second = '0'] = match;
            dateObj = new Date(+year, +month - 1, +day, +hour, +minute, +second);
        } else {
            return String(input);
        }

        // 如果最终还是无效日期
        if (!dateObj || isNaN(dateObj.getTime())) return String(input);

        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();

        if (!withTime) {
            return `${day}/${month}/${year}`;
        }

        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    formatCPF(id: any): string {
        const digits = id.toString().replace(/\D/g, '');
        if (digits.length !== 11) {
            return id;
        }
        const part1 = digits.substring(0, 3);
        const part2 = '***';
        const part3 = '***';
        const part4 = digits.substring(9, 11);
        return `${part1}.${part2}.${part3}-${part4}`;
    }

    /**
     * 是否是快盘交税模式
     * @returns 
     */
    modeTaxes() {
        return import.meta.env.VITE_TAXEA_MODE
    }

    /**
     * V8模式
     * @returns 
     */
    modeTaxesV8() {
        return import.meta.env.VITE_TAXEA_MODE == 'V8'
    }
    /**
     * 注册赠送图标
     * @returns 
     */
    registerGiftLogo() {
        return this.modeTaxesV8()
    }
    /**
     * 新用户注册转盘抽奖
     */
    registerDraw() {
        return this.modeTaxesV8()
    }
    /**
     * 新用户进入所有游戏都需要先充值
     */
    rechargeBeforeOpenAllGames() {
        return this.modeTaxesV8()
    }
}

export let GameUtil = gameUtil.Instance;

export function getImageDimensions(file: File): Promise<{ width: number; height: number }> {
    return new Promise((resolve, reject) => {
        if (!(file instanceof Blob)) {
            return reject(new Error('传入的 file 不是 Blob 类型'));
        }

        const reader = new FileReader();
        reader.onload = function (e) {
            const img = new Image();
            img.onload = () => resolve({ width: img.width, height: img.height });
            img.onerror = reject;
            img.src = e.target?.result as string;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export function copyToClipboard(content: string): Promise<void> {
    return new Promise((resolve, reject) => {
        // 首选使用 Clipboard API
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(content).then(resolve).catch(reject);
        } else {
            // 回退方案：创建临时 textarea 复制
            const textArea = document.createElement('textarea');
            textArea.value = content;
            textArea.style.position = 'fixed'; // 避免页面滚动
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                const successful = document.execCommand('copy');
                document.body.removeChild(textArea);
                if (successful) {
                    resolve();
                } else {
                    reject(new Error('Copy command was unsuccessful'));
                }
            } catch (err) {
                document.body.removeChild(textArea);
                reject(err);
            }
        }
    });
}

export async function handlePaste() {
    try {
        const text = await navigator.clipboard.readText();
        return text;
    } catch (err) {
        console.error('粘贴失败：', err);
        return '';
    }
}

// 检测是否以PWA模式运行
export const isRunningAsPWA = (): boolean => {
    return (
        window.matchMedia('(display-mode: standalone)').matches ||
        (window.navigator as any).standalone ||
        document.referrer.includes('android-app://') ||
        window.matchMedia('(display-mode: minimal-ui)').matches
    );
};

export const isRunApp = () => {
    return import.meta.env.VITE_PLATFORM === 'android' || 'jsBridge' in window;
};

// 检查通知权限状态
export const checkNotificationPermission = (): NotificationPermission => {
    return Notification.permission;
};

// 请求通知权限（返回Promise）
export const requestNotificationPermission = async (): Promise<NotificationPermission> => {
    return await Notification.requestPermission();
};

declare global {
    interface Window {
        clarity?: (...args: any[]) => void;
    }
}

export const waitForClarity = (): Promise<typeof window.clarity> => {
    return new Promise((resolve, reject) => {
        let retry = 0;
        const check = () => {
            if (window.clarity) {
                resolve(window.clarity);
            } else if (retry++ > 100) {
                reject(new Error('Clarity 加载失败'));
            } else {
                setTimeout(check, 300);
            }
        };
        check();
    });
};

export const getLocalizedImg = (basePath: string, locale: string) => {
    const lang = locale.toLowerCase();
    // 支持的语言后缀
    const supportedLocales = ['my-mm', 'en-ph'];
    const shouldUseLocale = supportedLocales.includes(lang);

    // 获取文件扩展名
    const ext = basePath.substring(basePath.lastIndexOf('.'));

    // 分离掉 "xx.webp" 得到 "xx"
    const withoutExt = basePath.replace(ext, '');

    // 拼多语言文件路径
    const localizedPath = shouldUseLocale ? `${withoutExt}_${lang}${ext}` : basePath;

    // 使用 Vite 的 new URL 构建最终可访问路径
    const resolvedLocalized = new URL(localizedPath, import.meta.url).href;
    const resolvedDefault = new URL(basePath, import.meta.url).href;

    // 根据语言是否需要本地化来返回对应路径
    return shouldUseLocale ? resolvedLocalized : resolvedDefault;
};

/**
 * 根据后缀动态返回多语言图片
 * @param baseName 例如 mysterious_mission_card_1
 * @param ext 例如 webp
 */
export const getLocalizedImgold = (baseName: string, locale: string) => {
    const lang = locale.toLowerCase();

    // 多语言路径
    const localizedPath = generateLocalizedImagePath(baseName, locale);

    // 默认路径（无后缀）
    const defaultPath = baseName;

    // 创建一个 img 测试是否存在本地化文件（H5/APP 都支持）
    const image = new Image();
    image.src = localizedPath;

    // 如果本地化资源加载失败 → 回到默认图
    image.onerror = () => (image.src = defaultPath);

    return localizedPath;
};

// 生成本地化图片路径
function generateLocalizedImagePath(originalPath: string, currentLocale: string): string {
    // 支持的语言列表
    const supportedLocales = ['my-mm', 'en-ph'];
    console.log(
        'src 拦截 对比',
        currentLocale,
        supportedLocales,
        supportedLocales.includes(currentLocale)
    );

    // 如果当前语言不是支持的语言或者是默认语言，使用原图
    if (!supportedLocales.includes(currentLocale)) {
        return originalPath;
    }
    // 替换路径：@/assets/img/agencom/0036_yuce_bai.webp → @/assets/img/agencom/0036_yuce_bai_pt.webp
    return originalPath.replace(/(\.[^/.]+)$/, `_${currentLocale.replace('-', '_')}$1`);
}
